import { initContract } from "@ts-rest/core";
import { IntegrationTransactionDto } from "../dto/transactions/integration-transaction.dto";
import { z } from "zod";

const c = initContract();

export const integrationTransactionContract = c.router({
    getIntegrationTransactions: {
        path: "/integration-account/:integrationAccountId/integration-transactions",
        method: "GET",
        responses: {
            200: c.type<{ data: IntegrationTransactionDto[] }>(),
        },
    },
    updateIntegrationTransaction: {
        path: "/integration-account/:integrationAccountId/integration-transaction/:integrationTransactionId",
        method: "PATCH",
        body: z.object({
            date: z.string().date().optional(),
            amount: z.number().optional(),
            bankDescription: z.string().optional(),
        }),
        responses: {
            200: c.type<IntegrationTransactionDto>(),
        },
    },
});
